<template>
	<div>
		<div class="py-4" > 
			<div class="d-flex h-100 align-items-center" v-if="do_later">
				<do-later ></do-later>
			</div>
			<div class="d-flex h-100 align-items-center" v-else>
				<!------step-one---->	
				<app-step-one v-if="parseInt(get_user.step) == 0"></app-step-one>
				<!------step-four---->
				<app-step-four v-else-if="parseInt(get_user.step) == 1"></app-step-four>
				<!------step-five---->
				<app-step-five v-else-if="parseInt(get_user.step) == 2"></app-step-five>
				<!-------ticket view page----->
				<support-view v-else-if="parseInt(get_user.step) == 3" :ticketId="ticket_id"></support-view>
			</div>
		</div>
	</div>
</template>
<script>
	import step1 from '../registerSteps/step1'
	import step2 from '../registerSteps/step2'
	import step3 from '../registerSteps/step3'
	import step4 from '../registerSteps/step4'
	import step5 from '../registerSteps/step5'
	import doLater from '../registerSteps/do_later'
	import supportView from '../supports/view.vue'
	import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'steps',
		mixins: [fxViewMixins],
        data() {
            return {
				do_later : false,
				ticket_id : ''
            }
        },
		components: {
			doLater: doLater, 
			appStepOne: step1, 
			appStepTwo: step2, 
			appStepThree: step3, 
			appStepFour: step4, 
			appStepFive: step5,
			supportView : supportView
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/register_steps.vue